export enum LogInvoicesActions {
  GENERATE = "GENERATE",
  CANCEL = "CANCEL",
}
